import styled from "@emotion/styled";
import { Box } from "Components";

export const MentorNameCell = styled(Box)`
    background: #fff;
    min-height: 60px;
    padding: 10px;
    display: flex;
    align-items: center;
    min-width: 110px;
`;
